import { t } from "i18next";
import { string } from "yup";

import { CUSTOM_INSTRUCTIONS_MAX_LENGTH } from "./customInstructionsConstants";

export const customInstructionsSchemaField = () =>
  string()
    .max(
      CUSTOM_INSTRUCTIONS_MAX_LENGTH,
      t("Must be at most {{max}} characters", {
        max: CUSTOM_INSTRUCTIONS_MAX_LENGTH,
      })
    )
    .optional()
    .nullable();
